import React, { useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import FailureAlert from '../Common/Failure';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { ThemeContext } from '../Common/ThemeProvider';

const enquiry = {
    Subject: "",
    Remarks: "",
    CreatedBy: 0,
    Destination: "",
    SurveyRequired: 0,
    MoveType: "",
    Country: "India",
    State: "",
    City: "",
    Status: 1,
    IsDeleted: 0
};

const Subjects = [{
    label: "Movement Enquiry",
    value: 1
}];

const Destination = [
    {
        label: "Local",
        value: 2
    },
    {
        label: "Domestic",
        value: 1
    },
    {
        label: "International",
        value: 3
    }];

const MoveType = [{
    label: "Household",
    value: 1
},
{
    label: "Automobiles",
    value: 2
},
{
    label: "Pet Re-Location",
    value: 3
},
{
    label: "Household + Automobiles",
    value: 4
}];

const NewEnquiry = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Enquiry, setEnquiry] = useState(enquiry);

    const OnSubjectChange = (subjectData) => {
        let subject = subjectData ? subjectData.label : "";
        if (subject !== "") {
            setEnquiry({ ...Enquiry, "Subject": subject });
        }
    };

    const OnDestinationChange = (DestData) => {
        let Dest = DestData ? DestData.label : "";
        if (Dest !== "") {
            setEnquiry({ ...Enquiry, "Destination": Dest });
        }
    };

    const OnSurveyChange = (e) => {
        let surveyRequired = e.target.checked ? 1 : 0;
        setEnquiry({ ...Enquiry, "SurveyRequired": surveyRequired });
    };

    const OnMoveTypeChange = (MoveTypeData) => {
        let MoveTypelabel = MoveTypeData ? MoveTypeData.label : "";
        setEnquiry({ ...Enquiry, "MoveType": MoveTypelabel });
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setEnquiry({ ...Enquiry, [e.target.name]: value });
    };

    const SaveEnquiryDetails = () => {
        if (ValidatEnquiry(Enquiry)) {
            var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
            if (userData !== null) {
                let EnquiryData = Enquiry;
                var parsedUserData = JSON.parse(userData);
                let UserID = parsedUserData._id;
                EnquiryData.CreatedBy = UserID;
                EnquiryData.AgentID = null;
                Axiosfetch(baseURL + "CreateEnquiry", "POST", EnquiryData, AddEnquirySuccess, Failure);
            }
        }
    };

    const ValidatEnquiry = (enquiry) => {
        let enqErr = "";
        if (enquiry.Subject === "") {
            enqErr = "Please enter Subject";
        }
        else if (enquiry.Destination === "") {
            enqErr = "Please enter Destination";
        }
        else if (enquiry.MoveType === "") {
            enqErr = "Please enter MoveType";
        }
        else if (enquiry.Country === "") {
            enqErr = "Please enter Country";
        }
        else if (enquiry.State === "") {
            enqErr = "Please enter State";
        }
        else if (enquiry.City === "") {
            enqErr = "Please enter City";
        }

        if (enqErr !== "") {
            Alert.error(enqErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const AddEnquirySuccess = (data) => {
        if (data.success) {
            setEnquiry(enquiry);
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Enquiry Form</h5>
                    </div>
                </div>
                <div className="row" style={{ height: "76vh", overflow: "auto", display: "flex", justifyContent: "space-around" }}>
                    <div className="col-md-8" style={{ border: "1px solid #ccc", borderRadius: "6px", padding: "10px", marginBottom: "10px" }}>
                        <div>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <h5>Subject<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Subject"
                                                    options={Subjects}
                                                    onChange={OnSubjectChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <h5>Service Type<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Destination"
                                                    options={Destination}
                                                    onChange={OnDestinationChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <h5>Items Type<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Move Type"
                                                    options={MoveType}
                                                    onChange={OnMoveTypeChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <div style={{ border: "1px solid #ccc", borderRadius: "6px", padding: "10px 10px 20px 10px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-around" }}>
                                                    <span>Country<span className="mandatoryStar">*</span></span>
                                                    <span>State<span className="mandatoryStar">*</span></span>
                                                    <span>City<span className="mandatoryStar">*</span></span>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <input style={{ margin: "0 20px", textAlign:"center" }} value={Enquiry.Country} name="Country" type="text" onChange={e => onTextChange(e)} className="form-control"></input>
                                                    <input style={{ margin: "0 20px", textAlign:"center" }} value={Enquiry.State} name="State" type="text" onChange={e => onTextChange(e)} className="form-control"></input>
                                                    <input style={{ margin: "0 20px", textAlign:"center" }} value={Enquiry.City} name="City" type="text" onChange={e => onTextChange(e)} className="form-control"></input>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <h5>Remarks</h5>
                                        </td>
                                        <td>
                                            <div>
                                                <textarea
                                                    onChange={e => onTextChange(e)}
                                                    rows="2"
                                                    className="form-control" name="Remarks"
                                                    value={Enquiry.Remarks}></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style={{ textAlign: "right" }}>
                                        <td colSpan="2">
                                            <div>
                                                <div className="switch">
                                                    <input
                                                        onChange={e => OnSurveyChange(e)} id="switch1"
                                                        type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch1" className="switch-label">Switch</label>
                                                </div>
                                                <span style={{ paddingLeft: "10px" }}>Survey Required</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="align-right">
                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} 
                                onClick={SaveEnquiryDetails}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewEnquiry;